module.exports = __webpack_public_path__ + "img/icono_3_people.50ac17dd.png";